import React from 'react';
import CreditPlateHome from '../components/creditplate-home';

const Home = () => <CreditPlateHome />;

export default Home;
